module.exports = __webpack_public_path__ + "static/media/v4.f011efd7.mp4";